import fetch from '@/utils/fetch';
import * as API from '@/commons/http-api';

export default {
  namespace: 'sign',
  state: {
    meetingId: '',
    result: '',
  },
  reducers: {
    setResult(state, action) {
      return {
        ...state,
        result: action.payload,
      };
    },
  },
  effects: {
    *getResult(action, { put }) {
      const { id, callback = () => {} } = action.payload;
      const res = yield fetch.get(API.MEETING_SIGN(id));
      if (callback && typeof callback === 'function') {
        callback(res.data);
      }
      yield put({
        type: 'setResult',
        payload: res.data,
      });
    },
  },
};
